import { API_NAME } from '@/constants'

export default {
  Auth: {
    region: process.env.VUE_APP_AWS_REGION,
    userPoolId: process.env.VUE_APP_AWS_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_AWS_COGNITO_USER_POOL_CLIENT_ID,
    oauth: {
      domain: process.env.VUE_APP_AWS_COGNITO_OAUTH_DOMAIN,
      scope: ['openid', 'profile'],
      responseType: 'code',
      redirectSignIn: process.env.VUE_APP_AWS_COGNITO_OAUTH_REDIRECT_URI,
      redirectSignOut: process.env.VUE_APP_AWS_COGNITO_OAUTH_SIGN_OUT_URI
    }
  },
  API: {
    endpoints: [
      {
        name: API_NAME,
        endpoint: process.env.VUE_APP_AWS_API_ENDPOINT
      }
    ]
  }
}
